import { createFileRoute } from '@tanstack/react-router'
import { ActivityTypesPage } from '@/features/activity-types'

export const Route = createFileRoute('/_authenticated/activity-types/')({
  component: ActivityTypesPage,
})
